export const PortsOut = {
  position: {
    name: "right",
  },
  attrs: {
    portBody: {
      magnet: true,
      r: 6,
      fill: "#E6A502",
      stroke: "#023047",
    },
  },
  label: {
    position: {
      name: "right",
      args: { y: 6 },
    },
    markup: [
      {
        tagName: "text",
        selector: "label",
        className: "label-text",
      },
    ],
  },
  markup: [
    {
      tagName: "circle",
      selector: "portBody",
    },
  ],
};
